module.exports = __webpack_public_path__ + "img/UP.5f90c9e7.png";